import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import TemplateAdapter from "components/adapters/TemplateAdapter";
import BreadcrumbAdapter from "components/adapters/BreadcrumbAdapter";
import TrabalhadorPrestadores from "./TrabalhadorPrestadores";
import * as StatusManagerActions from "../../../../actions/StatusManagerActions";
import * as RedirectActions from "../../../../actions/RedirectActions";

const TrabalhadorPrestadoresIndex = (props) => {
  useEffect(() => {
    props.action.showManager();
    props.action.redirectClear();
  }, [props.action]);

  if (props.redirect.url) {
    return <Redirect to={props.redirect.url} />;
  }

  return (
    <TemplateAdapter>
      <BreadcrumbAdapter
        data={[
          {
            titulo: "Relatório Prestadores",
            link: "/manager/relatorios",
          },
          { titulo: "Trabalhadores" },
        ]}
      />
      <TrabalhadorPrestadores />
    </TemplateAdapter>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    managerStatus: state.managerStatus,
    redirect: state.redirectReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    action: bindActionCreators(
      {
        ...StatusManagerActions,
        ...RedirectActions,
      },
      dispatch,
    ),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TrabalhadorPrestadoresIndex),
);
